













import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {FusionThemesDefault, WidgetDefinition, WSize} from '@/components/widgets/WidgetFather'
import WidgetFrame from '@/components/WidgetFrame.vue'
import FusionChart from '@/components/charts/FusionChart.vue'
import {getStoredProcedure} from '@/data/repos/storedProcedure'

@Component({
  components: {
    FusionChart,
    WidgetFrame,
  },
})
export default class CarterMetrics extends Vue {
  @Prop() public config!: WidgetDefinition
  private chartDSClinical: any = {chart: {}}
  private chartDSUtilisation: any = {chart: {}}
  private chartConfig = {
    title: 'Carter Metrics',
    type: 'pie2d',
    width: WSize.dbl.w,
    height: WSize.dbl.h,
    chartDataFormat: 'json',
  }
  private chartDataConfig = {
    caption: '',
    //subcaption: '',
    //yaxisname: '',
    //xaxisname: '',
    //numbersuffix: '',
    //rotatelabels: '1',
    //setadaptiveymin: '1',
    theme: 'micad',
    legendCaption: 'Legend'
  }

  @Watch('config', {immediate: true, deep: true})
  public onConfigChange(val: WidgetDefinition) {
    this.chartConfig.type = val.cType || 'pie2d'
    this.chartDSClinical.chart.theme = val.theme || FusionThemesDefault
    this.chartDSUtilisation.chart.theme = val.theme || FusionThemesDefault
  }

  public async created() {
    Promise.all([this.getCarterMetricsClinical(), this.getCarterMetricsUtilisation()]).then((data) => {
      this.chartDSClinical = {chart: {...this.chartDataConfig, ...{caption: 'Clinical'}}, data: data[0]}
      this.chartDSUtilisation = {chart: {...this.chartDataConfig, ...{caption: 'Utilisation'}}, data: data[1]}
    })
  }

  private getCarterMetricsClinical(): Promise<Array<{ label: string, value: string }>> {
    return getStoredProcedure('AnalyticsCenter', 'widget_CarterClinical', [10, 1], this.noValueFilter)
  }

  private getCarterMetricsUtilisation(): Promise<Array<{ label: string, value: string }>> {
    return getStoredProcedure('AnalyticsCenter', 'widget_CarterUtilisation', [10, 1], this.noValueFilter)
  }

  private noValueFilter(data: any[]): any[] {
    const filteredData = []
    for (const item of data) {
      filteredData.push({
        ...item,
        Color: item.Label == 'No value!' ? '#C50000' : null
      })
    }
    return filteredData
  }

  public chartClickCallback(label: string, val: any) {
    console.log('chartClickCallback', label, val)
    // const url = 'https://ipr3-6-dev.micadipr.net/MicadAnalyticsCenter/widget/10'
    // window.open(url)
    // TODO
  }
}
